import { render, staticRenderFns } from "./inbox-control.vue?vue&type=template&id=1b416224"
import script from "./inbox-control.vue?vue&type=script&lang=js"
export * from "./inbox-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports